import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { CustBusService } from 'src/app/services/customer-search-bussiness-logic.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import * as Constants from 'src/app/models/Constants';
import { LogService } from 'src/app/services/log.service';
import { environment } from 'src/environments/environment';
declare var $: any;


@Component({
  selector: 'app-database-selector',
  templateUrl: './database-selector.component.html',
  styleUrls: ['./database-selector.component.scss']
})
export class DatabaseSelectorComponent implements OnInit {

  databaseSelectorForm: FormGroup = new FormGroup({});
  private readonly defaultUdpDatabaseNameRegexList: RegExp[] = [/x$/i];
  private udpDatabaseNameRegexList: RegExp[] = this.defaultUdpDatabaseNameRegexList;
  public udpDataBaseName: string = "";
  public tbaLifeCycle: string = "";
  public transId: string = "";
  public tempClient: string = "";
  public crrUdpDataBaseName: string = "";
  public crrTbaLifeCycle: string = "";
  public crrTransId: string = "";
  public isTBAClient: boolean = true;
  public isClientSelected = false;
  public isDatabaseSelectorApiFailure = false;
  public listApiFailure = false;
  public errorMessage = Constants.EXTERNAL_API_FAILURE_MSG;
  public disable: boolean = false;
  fileName: string = 'databaseSelectorComponent';

  constructor(
    public rootService: RootScopeService,
    public customerService: CustBusService,
    public dialogRef: MatDialogRef<void>,
    private fb: FormBuilder,
    private apiService: ApiService,
    private logService: LogService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }



  ngOnInit(): void {

    this.disable = false;
    this.databaseSelectorForm = this.fb.group({
      clientId: new FormControl(),
      udpDatabaseName: new FormControl('', [Validators.required, this.udpDatabaseNameRegexValidator()]),
      tbaLifeCycle: new FormControl(),
      transId: new FormControl(),
      clientName: new FormControl(null, [
        Validators.required
      ])
    });
    if (this.isDvOrQaEnvironment()) {
      this.loadUdpDatabaseNameRegexList();
    } else {
      this.udpDatabaseNameRegexList = [];
      this.databaseSelectorForm.get('udpDatabaseName')?.updateValueAndValidity();
    }
  }

  loadUdpDatabaseNameRegexList() {
    this.apiService.getDataByCommonKeyValueApi(Constants.UDP_DATABASE_NAME_REGEX_LIST_KEY).subscribe({
      next: (res: any) => {
        const regexList = res?.data?.body;
        this.udpDatabaseNameRegexList = this.normalizeUdpDatabaseNameRegexList(regexList);
        this.databaseSelectorForm.get('udpDatabaseName')?.updateValueAndValidity();
      },
      error: (err) => {
        this.logService.errorLogs('There was a problem loading the UDP database regex list. Using default validation.' + JSON.stringify(err), this.fileName);
        this.udpDatabaseNameRegexList = this.defaultUdpDatabaseNameRegexList;
        this.databaseSelectorForm.get('udpDatabaseName')?.updateValueAndValidity();
      }
    });
  }

  isDvOrQaEnvironment(): boolean {
    let url_address = window.location.href;
    return url_address.includes(Constants.DEV_ENV) || url_address.includes(Constants.QA_ENV) || url_address.includes("local");
  }

  getTBALifeCycleList() {
    this.apiService.getDataByCommonKeyValueApi(Constants.TBAGUI_LIFECYCLE).subscribe({
      next: (res: any) => {
        if (res && res?.data && res?.data?.body) {
          this.rootService.tbaguiLifeCycleList = res?.data?.body;
          this.rootService.tbaguiLifeCycleAPIFailure = false;
        }
      },
      error: (err) => {
        this.logService.errorLogs("There was a problem loading the data. Try again." + JSON.stringify(err), this.fileName);
        this.rootService.tbaguiLifeCycleAPIFailure = true;
        return null;
      }
    })
  }


  getTBALifecycleName(Id) {

    let name = this.rootService.tbaguiLifeCycleList.find(x => x.fieldValue == Id)?.fieldValueDescription;
    return name
  }

 
  onClientDropDownChange(event) {
    if (event && event?.['value']) {

      this.disable = true;
      console.log(event)
      let selectedClient = event?.['value'];
      if (this.tempClient != selectedClient) {
        this.tempClient = selectedClient;
        // clear field
        this.transId = "";
        this.udpDataBaseName = "";
        this.tbaLifeCycle = "";
        this.crrTransId = "";
        this.crrUdpDataBaseName = "";
        this.crrTbaLifeCycle = "";
        this.isClientSelected = true;
        this.blankDBSelecterValues();
        
      }
      console.log(selectedClient)
      this.udpDataBaseName = this.getMappedValFromClientSystemData("UDP", "TEST-CFG", selectedClient, "COMMON");
      let mappedTbaLifeCycle = this.getMappedValFromClientSystemData("TBA-GUI", "LIFECYCLE", selectedClient, "COMMON");
      if (mappedTbaLifeCycle !== 'NA' && mappedTbaLifeCycle !== '' && mappedTbaLifeCycle !== undefined) {
        this.tbaLifeCycle = mappedTbaLifeCycle;
      } else {
        this.tbaLifeCycle = this.rootService.isCarePortalProd ? 'P' : 'A';
      }

      if (this.rootService.dataBaseSelecterMap[this.databaseSelectorForm.value.clientId]) {
        this.crrTbaLifeCycle = this.rootService.dataBaseSelecterMap?.[this.databaseSelectorForm.value.clientId]?.LIFECYCLE;
        this.crrUdpDataBaseName = this.rootService.dataBaseSelecterMap?.[this.databaseSelectorForm.value.clientId]?.['TEST-CFG'];
      } else {
        this.crrTbaLifeCycle = this.tbaLifeCycle;
        this.crrUdpDataBaseName = this.udpDataBaseName;
      }


      if (this.tbaLifeCycle != 'NA' && this.tbaLifeCycle != '' && this.tbaLifeCycle != undefined) {
        this.transId = this.getMappedValFromClientSystemData("TBA-GUI", "TRANS-ID", selectedClient, "COMMON");
        if (this.rootService.dataBaseSelecterMap[this.databaseSelectorForm.value.clientId]) {
          this.crrTransId = this.rootService.dataBaseSelecterMap?.[this.databaseSelectorForm.value.clientId]?.['TRANS-ID'];
        } else {
          this.crrTransId = this.transId;
        }

        this.isTBAClient = true;
        this.databaseSelectorForm.controls['tbaLifeCycle'].setValidators([Validators.required]);
        this.databaseSelectorForm.controls['transId'].setValidators([Validators.required]);
      }
      // else {
      //   this.isTBAClient = false;
      //   this.tbaLifeCycle = "";
      //   this.crrTbaLifeCycle = "";
      //   this.databaseSelectorForm.controls['tbaLifeCycle'].clearValidators();
      //   this.databaseSelectorForm.controls['transId'].clearValidators();
      // }
      this.databaseSelectorForm.controls['tbaLifeCycle'].updateValueAndValidity();
      this.databaseSelectorForm.controls['transId'].updateValueAndValidity();

    }
  }




  /**
   * Closes the database selector dialog if it is open.
   * Utilizes the `dialogRef` to close the dialog.
   */
  closeDatabaseSelector() {
    this.dialogRef?.close();
  }

  submitDbChange() {
    try {
    let payload =
    {
      "userDataBaseMap": {
        [this.databaseSelectorForm.value.clientId]: {
          "LIFECYCLE": this.databaseSelectorForm.value.tbaLifeCycle,
          "TRANS-ID": this.databaseSelectorForm.value.transId,
          "TEST-CFG": this.databaseSelectorForm.value.udpDatabaseName
        }
      }
    }
 
    this.apiService.saveDatabaseSelecter(payload).subscribe({     
      next: (res: any) => {
        console.log(res);
      
        this.rootService.dataBaseSelecterMap[this.databaseSelectorForm.value.clientId] = payload.userDataBaseMap[this.databaseSelectorForm.value.clientId]
        this.crrUdpDataBaseName = this.databaseSelectorForm.value.udpDatabaseName;
        this.crrTbaLifeCycle = this.databaseSelectorForm.value.tbaLifeCycle;
        this.crrTransId = this.databaseSelectorForm.value.transId;        
        this.isDatabaseSelectorApiFailure=false;
        this.blankDBSelecterValues();
      },
      error: (err) => {
        this.isDatabaseSelectorApiFailure=true;
        console.log(err)     
        this.errorMessage = Constants.SAVING_DATA_API_FAILURE_MSG ;
      }
    })
  } catch (error) {
    console.log(error);
  }

  }

  blankDBSelecterValues(){  
    let clientName =this.databaseSelectorForm.value.clientName;    
    $('#dbSelecterForm')[0]?.reset();
    this.databaseSelectorForm.get('clientId')?.setValue(this.tempClient);
    this.databaseSelectorForm.get('clientName')?.setValue(clientName);        
  }

  onClearSelection(clearFlag: boolean): void {
    if (clearFlag) {
      this.blankDBSelecterValues();
      console.log('Clear button was clicked, selection has been cleared.');
    }
  }

  resetToDefault() {
    this.databaseSelectorForm.get('udpDatabaseName')?.setValue(this.udpDataBaseName);
    this.databaseSelectorForm.get('tbaLifeCycle')?.setValue(this.tbaLifeCycle);
    this.databaseSelectorForm.get('transId')?.setValue(this.transId);  
  }

  normalizeUdpDatabaseNameRegexList(regexList?: Array<string | RegExp | { fieldValue?: string; fieldValueDescription?: string }>): RegExp[] {
    if (!Array.isArray(regexList) || regexList.length === 0) {
      return this.defaultUdpDatabaseNameRegexList;
    }

    const normalized = regexList
      .map((pattern) => this.toRegex(pattern))
      .filter((pattern): pattern is RegExp => pattern instanceof RegExp);

    return normalized.length ? normalized : this.defaultUdpDatabaseNameRegexList;
  }

  udpDatabaseNameRegexValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = String(control.value ?? '').trim();

      if (!value || !this.udpDatabaseNameRegexList.length) {
        return null;
      }

      const hasBlockedPattern = this.udpDatabaseNameRegexList.some((pattern) => pattern.test(value));

      return hasBlockedPattern ? { udpDatabaseNameRegex: true } : null;
    };
  }

  toRegex(pattern: string | RegExp | { fieldValue?: string; fieldValueDescription?: string }): RegExp | null {
    const patternValue = typeof pattern === 'string'
      ? pattern
      : pattern instanceof RegExp
        ? pattern.source
        : pattern?.fieldValue ?? pattern?.fieldValueDescription ?? '';

    if (!patternValue) {
      return null;
    }

    const literalMatch = patternValue.match(/^\/(.*)\/([gimsuy]*)$/);
    if (literalMatch) {
      return new RegExp(literalMatch[1], literalMatch[2]?.replace(/[gy]/g, ''));
    }

    if (pattern instanceof RegExp) {
      return new RegExp(pattern.source, pattern.flags.replace(/[gy]/g, ''));
    }

    return new RegExp(patternValue);
  }

  getMappedValFromClientSystemData(systemName, attributeName, clntId, domainName?) {

    let data = this.rootService.clientSystemIds.find(x => x.clientId == clntId);
    let key = '';
    if (domainName && domainName != 'undefined') {
      key = clntId + "-" + systemName + "-" + domainName + '-' + attributeName;
    }
    else {
      key = clntId + "-" + systemName + "-" + 'COMMON' + '-' + attributeName;
    }
    if (data?.data?.[key]) {
      return data?.data[key]?.targetSystemAttributeValue;
    }
    else
      return 'NA';
  }



}
